import wrappersTypes from '../constants/wrappers-types';

const getSupportedTagNames = () => Object.values(wrappersTypes).map((type) => type.tagName);

export default getSupportedTagNames;
